import { motion } from "framer-motion";
import { MapPin, Clock, ExternalLink } from "lucide-react";
import { ADDRESS, MAPS_URL, MAPS_EMBED, HOURS } from "@/data/site";

export default function Location() {
  return (
    <section id="location" className="relative py-24 lg:py-32 bg-surface border-t border-steel" data-testid="location-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5"
        >
          <p className="font-mono text-xs uppercase tracking-widest text-hazard font-semibold mb-3">/ 06 — Find the Shop</p>
          <h2 className="font-heading uppercase font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white leading-[0.95]">
            Roll Into <span className="chrome-text">Bloomington</span>
          </h2>

          <div className="mt-8 space-y-5">
            <div className="flex items-start gap-4">
              <span className="w-10 h-10 border border-steel bg-card flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5 text-hazard" />
              </span>
              <div>
                <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Shop Address</p>
                <p className="font-heading font-bold uppercase text-xl text-white mt-1" data-testid="location-address-text">{ADDRESS}</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="w-10 h-10 border border-steel bg-card flex items-center justify-center shrink-0">
                <Clock className="w-5 h-5 text-hazard" />
              </span>
              <div>
                <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Hours</p>
                <p className="text-slate-300 text-sm mt-1" data-testid="location-hours-text">{HOURS}</p>
              </div>
            </div>
          </div>

          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="location-google-maps-link"
            className="mt-8 inline-flex items-center gap-3 px-7 py-4 border border-hazard text-hazard font-heading font-bold uppercase tracking-wide hover:bg-hazard hover:text-carbon transition-colors duration-300"
          >
            Get Directions <ExternalLink className="w-4 h-4" />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-7 border border-steel overflow-hidden"
          data-testid="location-map-frame"
        >
          <iframe
            title="GSX Diesel Truck Repair location map"
            src={MAPS_EMBED}
            className="w-full h-[380px] grayscale invert-[0.9] contrast-[0.9]"
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  );
}
